import React from 'react';
import { render } from 'react-dom';
import { browserHistory, IndexRoute, Router, Route } from 'react-router';

// Baseline style sheet:
import '../css/baseline.css';

// Application Shell and Pages:
import Application from './pages/Application';
import HomePage from './pages/HomePage';
import SeriesPage from './pages/SeriesPage';
import WorksPage from './pages/WorksPage';
import WorkPage from './pages/WorkPage';
import Resume from './pages/Resume';
import Press from './pages/Press';
import Contact from './pages/Contact';

function scrollToTop() {
  window.scrollTo(0, 0);
}

if (/jenniferzwick\.com$/.test(location.hostname) && location.protocol === 'http:') {
  location.replace(location.href.replace(/^http\b/, 'https'));
} else {
  render(
    (
      <Router history={browserHistory}>
        <Route path="/" component={Application}>
          <IndexRoute component={HomePage} onEnter={scrollToTop} />
          <Route path="/series/:seriesId" component={SeriesPage} onEnter={scrollToTop} />
          <Route path="/works" component={WorksPage} onEnter={scrollToTop} />
          <Route path="/works/:workId" component={WorkPage} onEnter={scrollToTop} />
          <Route path="/works/:workId/:index" component={WorkPage} onEnter={scrollToTop} />
          <Route path="/resume" component={Resume} onEnter={scrollToTop} />
          <Route path="/press" component={Press} onEnter={scrollToTop} />
          <Route path="/contact" component={Contact} onEnter={scrollToTop} />
        </Route>
      </Router>
    ),
    document.getElementById('react'),
  );
}



// WEBPACK FOOTER //
// ./application/js/main.js